import React, { useEffect } from "react";
import HelpdeskContent from "./helpdesk/helpdesk-content";

const HelpCenter = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <HelpdeskContent />
  )
}

export default HelpCenter
